

export default {
    bind: function (el, binding) {
        let touchstart_x;
        let touchstart_y;

        function getDiffX(e) {
            const touchend_x = e.changedTouches[0].screenX;
            const touchend_y = e.changedTouches[0].screenY;
            const dif_x = touchstart_x - touchend_x;
            const dif_y = touchstart_y - touchend_y;
            return {
                x: dif_x,
                y: dif_y,
            };
        };

        const onTouchStart = (e) => {
            touchstart_x = e.touches[0].screenX;
            touchstart_y = e.touches[0].screenY;

            binding.value({ 
                type: 'touchstart',
            });
        };

        const onTouchEnd = (e) => {
            binding.value({ 
                type: 'touchend',
            });

            const diff = getDiffX(e);

            if (Math.abs(diff.y) > Math.abs(diff.x)) return;
            if (Math.abs(diff.x) < 50) return;
        
            binding.value({ 
                type: 'swipe', 
                axis: 'x',
                direction: (diff.x < 0) ?  -1 :  1, 
            });
        };

        const onTouchMove = (e) => {
            const diff = getDiffX(e);
            binding.value({ 
                type: 'touchmove', 
                value: diff,
            });
        };

        el.addEventListener('touchstart', onTouchStart);
        el.addEventListener('touchend', onTouchEnd);
        el.addEventListener('touchmove', onTouchMove);
        el.$destroy = () => {
            el.removeEventListener('touchstart', onTouchStart);
            el.removeEventListener('touchend', onTouchEnd);
            el.addEventListener('touchmove', onTouchMove);
        };
    },
    unbind: function (el) {
        el.$destroy();
    },
};